// extracted by mini-css-extract-plugin
export default {"wrapper":"xp-z","response":"yp-z","error":"zp-z","disabled":"Ap-z","buttons":"Bp-z","feedbackQuestionSection":"Cp-z","yesNoWrapper":"Dp-z"};